<template>
	<div class="tool-tip">
		<svg @mouseover="needHelp" @mouseleave="iGetIt" data-v-2afd4376="" version="1.1" meta="vk-icons-question" width="20" height="20" viewBox="0 0 20 20">
			<circle fill="none" stroke="#484848" stroke-width="1.1" cx="10" cy="10" r="9"></circle>
			<circle fill="#0057FF" cx="10.44" cy="14.42" r="1.05"></circle>
			<path fill="none" stroke="#484848" stroke-width="1.2" d="M8.17,7.79 C8.17,4.75 12.72,4.73 12.72,7.72 C12.72,8.67 11.81,9.15 11.23,9.75 C10.75,10.24 10.51,10.73 10.45,11.4 C10.44,11.53 10.43,11.64 10.43,11.75"></path>
		</svg>
		<div class="tool-tip-content" :class="{showing:show}">
			<slot></slot>
		</div>
	</div>
</template>

<script>

export default {
	name: "ToolTip",
	components:{

	},
	data() {
		return {
			show: false
		}
	},
	mounted() {
	},
	methods: {
		needHelp(){
			let contentBox = this.$el.querySelector(".tool-tip-content");
			let svg = this.$el.querySelector("svg");
			let svgPos = svg.getBoundingClientRect();
			contentBox.style.top = svgPos.top + "px";
			contentBox.style.left = (svgPos.right+10) + "px";
			this.show = true;
		},
		iGetIt(){
			this.show = false;
		}
	}
}
</script>
<style lang="less" scoped>
.tool-tip{
    display: inline-block;
    svg{
        transform: scale(0.8);
        position: relative;
        top: -5px;
        left: 3px;
        cursor: pointer;
    }

    &-content{
        position: fixed;
        top: 0;
        left: 0;
        z-index: 50;
        background: #ffffff;
        border: thin solid #CFD4D9;
        border-radius: 4px;
        transform: scale(0);
        transition: transform 0.3s;
        padding: 8px;
        max-width: 250px;
        -webkit-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.35);
        -moz-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.35);
        box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.35);

        &.showing{
            transform: scale(1);
        }

        p{
            margin-top: 0;
            padding-top: 0;
            font-family: "Plex Sans Regular", sans-serif;
            font-size: 12px;
            line-height: 13px;
        }
    }
}
</style>
